var map = {
	"./11 March 2021/bago_1_wounded(11.3.2021).jpeg": 2277,
	"./11 March 2021/bago_2_wounded(11.3.2021).jpeg": 2278,
	"./13 March 2021/pyay_1(13.3.2021).png": 2279,
	"./min thu ya/1.blur.jpg": 2280,
	"./min thu ya/1.jpg": 2281,
	"./min thu ya/2.blur.jpg": 2282,
	"./min thu ya/3.blur.jpg": 2283,
	"./myat thuzar khin/1.jpg": 2284,
	"./nay pyi taw abdomen shot/1.png": 2285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2276;